import { goDutch } from './go-dutch';
import { cashCanvas } from './cash-canvas';
import { teemates } from './teemates';
import { teematesTours } from './teemates-tours';
import { rideRoster } from './ride-roster';
import { trophyTally } from './trophy-tally';
import { printForge } from './print-forge';
import { mindMeld } from './mind-meld';
import { auraJournal } from './aura-journal';
import { lyricScroller } from './lyric-scroller';
import { gatvol } from './gatvol';
import { xtras } from './xtras';
import { whistleroll } from './whistleroll';
import { vamosly } from './vamosly';

export const CASE_STUDIES = [
  goDutch,
  cashCanvas,
  teemates,
  teematesTours,
  rideRoster,
  trophyTally,
  printForge,
  mindMeld,
  auraJournal,
  lyricScroller,
  gatvol,
  xtras,
  whistleroll,
  vamosly
];